import { CaseDeserialized } from "src/cases/queries/casesTypes";

export const useIsCaseCopilotEnabled = (
  caseData?: CaseDeserialized,
): boolean => {
  return (
    caseData?.data.template_version?.copilot_settings?.copilot_enabled ===
      true && caseData?.data.template_version?.copilot_reference != null
  );
};
